import cn from "classnames";
import { CardStatusProps } from "./CardStatus";

export const useCardStatusProps = (props: CardStatusProps) => {
  const { color, location, ...rest } = props;
  const output: string = status
    ? cn(`card-status-${location === "side" ? "start" : location} bg-${color}`)
    : "";

  return { className: output, ...rest };
};
